import DOMPurify from "isomorphic-dompurify";

export function validateSanitized(input: string): boolean {
  if (typeof input !== "string") {
    return false;
  }
  const sanitized = DOMPurify.sanitize(input);
  return sanitized === input;
}

export const maxFileSizeInMb = 2;
export const maxFontSizeInMb = 10;

export function validateFile(input: File, sizeInMb: number): boolean {
  const validType = input instanceof File;
  const validSize = input.size > 0 && input.size <= sizeInMb * 1024 * 1024;
  return validType && validSize;
}
